import { useQuery } from "@tanstack/react-query";
import { getExpenses } from "api/expense.api";

/**
 * All non-void purchase documents for a vendor — used to link a credit note to
 * the bill it credits, so the backend inherits that bill's account type.
 */
export const useGetVendorBills = (vendorId) => {
  return useQuery({
    queryKey: ["vendor-bills", vendorId],
    enabled: !!vendorId,
    queryFn: async () => {
      const data = await getExpenses({ vendorId });
      return (data?.documents || [])
        .filter((d) => d.status !== "VOID")
        .sort((a, b) => new Date(b.documentDate) - new Date(a.documentDate));
    },
    staleTime: 30 * 1000,
  });
};
